import { render, staticRenderFns } from "./tableConfig.vue?vue&type=template&id=60e74e52"
import script from "./tableConfig.vue?vue&type=script&lang=js"
export * from "./tableConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports